import ModelMeAIAnalytics from "../service/ModelMeAiAnalyticsService";

window.addEventListener('DOMContentLoaded', () => {
  ModelMeAIAnalytics.getPlausible()
});

